import { scrollToAndFlashQuestionnaireItem } from './scrollToQuestionnaireItem';
import { scrollToNoteMetadataField } from './scrollToNoteMetadataField';

function isMetadataScrollTarget(target: string): boolean {
  return (
    target.startsWith('billingRow-') ||
    target.startsWith('participant-location-') ||
    target === 'durationMinutes' ||
    target === 'billing-evaluation'
  );
}

/** Scroll to a questionnaire item path or note-metadata field key from a quality check row. */
export function scrollToNoteCheckTarget(target: string): boolean {
  if (isMetadataScrollTarget(target)) {
    return scrollToNoteMetadataField(target);
  }
  return scrollToAndFlashQuestionnaireItem(target);
}
